import { useCallback, useState } from 'react';
import { add } from 'ramda';

export const useRerender = () => {
	const [key, setKey] = useState(0);
	const handleRerender = useCallback(() => setKey(add(1)), []);
	return [key, handleRerender];
};
